<template>
    <div class="col-sm-12 py-3">
        <div v-if="reservation.payments">
            <div class="d-flex flex-row justify-content-between" v-for="payment in reservation.payments">
                <span>{{payment.date}}</span>
                <span>{{payment.value + ' ' + payment.currency }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return {

        }
    },
    props: {
        reservation: {
            type: Object
        }
    },
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// TabPayments.vue?e3aeed88